// Primeiro import do bundle: instala o Sentry ANTES do grafo de módulos do app,
// para capturar crash em module-scope (classe de falha do incidente do login, PR #1974).
import { setupSentry } from './sentry';

setupSentry();
